import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dr-mode-dialog',
  templateUrl: './dr-mode-dialog.component.html',
  styleUrls: ['./dr-mode-dialog.component.scss'],
  standalone: false
})
export class DrModeDialogComponent implements OnInit {

  title: string = '';
  message: string = '';
  confirmButtonText: string = '';
  cancelButtonText: string = '';
  optionSelection: any;
  drDetails: any;
  drAckCheckbox: boolean = false;
  drAckText: string = '';
  selectedOption: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<DrModeDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.title = this.data.title || this.title;
      this.message = this.data.message;
      this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
      this.cancelButtonText = this.data.cancelButtonText || this.cancelButtonText;
      this.optionSelection = this.data.optionSelection;
      this.drDetails = this.data.drDetails;
      this.drAckText = this.data.drAckText || this.drAckText;
      this.selectedOption = this.optionSelection?.find(opt => opt.selected);
    }
  }

  selectOptions(option: any): void {
    if (this.optionSelection) {
      for (const item of this.optionSelection) {
        if (item.selected) {
          item.selected = false;
        }
      }
    }
    option.selected = !option.selected;
    this.selectedOption = option;
  }

  toggleDrAckCheckbox(): void {
    this.drAckCheckbox = !this.drAckCheckbox;
  }

  onConfirm(): void {
    const selectedOption = this.optionSelection?.find((opt: any) => opt.selected);
    this.dialogRef.close(selectedOption);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
